"use client";

import { c as _c } from "react/compiler-runtime";
import ExpandableTweetPreview from "@/components/tweets/ExpandableTweetPreview";
interface BoostedTweetPreviewProps {
  readonly href: string;
  readonly tweetId: string;
}
const getFallbackLabel = (href: string): string => {
  try {
    const url = new URL(href);
    const host = url.hostname.replace(/^www\./i, "");
    return host || href;
  } catch {
    return href;
  }
};
const TweetFallback = t0 => {
  const $ = _c(8);
  const {
    href
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-iron-400">X post</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== href) {
    t2 = getFallbackLabel(href);
    $[1] = href;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="tw-flex tw-flex-col tw-gap-1">{t1}<span className="tw-[overflow-wrap:anywhere] tw-break-words tw-text-sm tw-font-semibold tw-text-iron-100">{t2}</span></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== href || $[6] !== t3) {
    t4 = <a href={href} target="_blank" rel="noopener noreferrer nofollow" className="tw-relative tw-flex tw-h-full tw-w-full tw-items-center tw-justify-start tw-rounded-xl tw-border tw-border-solid tw-border-white/10 tw-bg-black/30 tw-p-4 tw-text-left tw-no-underline tw-transition tw-duration-200 hover:tw-border-white/20">{t3}</a>;
    $[5] = href;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
export default function BoostedTweetPreview(t0) {
  const $ = _c(3);
  const {
    href,
    tweetId
  } = t0;
  let t1;
  if ($[0] !== href || $[1] !== tweetId) {
    t1 = <ExpandableTweetPreview href={href} tweetId={tweetId} renderFallback={_temp} />;
    $[0] = href;
    $[1] = tweetId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
function _temp(fallbackHref) {
  return <TweetFallback href={fallbackHref} />;
}